import React, { Component } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import Highcharts from "highcharts";
import { deepClone, shouldUpdate } from "../../../../utils";
import ReactHighcharts from "react-highcharts";
import ToggleChartSeries from '../../../ToggleChartSeries/ToggleChartSeries';

import styles from "./styles.scss";

const config = {
	chart: {
		animation: false,
		zoomType: "x",
		marginBottom: 85,
		panning: true,
		panKey: "shift",
		style: {
			fontFamily: "Helvetica"
		}
	},
	credits: {
		enabled: false
	},
	colors: ["#349EB3", "#536BAD"],
	title: {
		text: "History Graph 365",
		align: "left",
		margin: 60,
		style: {
			color: "#4D4D4D",
			"font-size": "20px",
			"font-weight": "600"
		}
	},
	plotOptions: {
		column: {
			grouping: false
		},
		line: {
			dataGrouping: {
				enabled: false,
				groupAll: true
			},
			turboThreshold: 0
		}
	},
	legend: {
		itemStyle: {
			color: "#999",
			fontWeight: "normal",
			fontSize: "14px"
		},
		align: "center",
		verticalAlign: "bottom",
		layout: "horizontal"
	},
	tooltip: {
		shared: true
	},
	xAxis: {
		type: "datetime",
		tickWidth: 0,
		lineColor: "#e6e6e6",
		labels: {
			y: 30,
			style: {
				fontSize: "14px",
				color: "#999"
			}
		}
	},
	yAxis: [
		{
			title: {
				text: "Hours",
				align: "high",
				rotation: 0,
				margin: 0,
				y: -30,
				offset: 14,
				style: {
					"font-weight": "600",
					"font-size": "15px"
				}
			},
			tickPositions: [0, 6, 12, 18, 24],
			labels: {
				style: {
					fontSize: "14px",
					color: "#999"
				}
			}
		}
	],
	series: []
};

@CSSModules(styles, { allowMultiple: true })
class DailyFailureChart extends Component {
	constructor(props) {
		super(props);
		this.chart = React.createRef();
		this.config = deepClone(config);
		this.config.title.text = this.props.component.chartTitle || this.config.title.text;
	}

	render() {
		return (
            <div>
                <ReactHighcharts config={this.config} ref={this.chart} isPureConfig={false} />
                <ToggleChartSeries chart={this.chart} />
            </div>
        ) 
	}

	setup() {
		let chart = this.chart.current.getChart();
		this.props.loadData(this.props.component, chart, this.props.timePeriod, this.props.onLoadComplete);
		setTimeout(() => {
		   if(chart) {
			  chart.reflow();
			  chart.redraw();
		   }
		}, 100);
	}

	teardown() {}

	componentDidMount() {
		this.setup();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		this.setup();
	}

	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
	}
}

const bindAction = dispatch => {
	return {
		loadData: (component, chart, timePeriod, onLoadComplete) => dispatch(actions.loadData(component, chart, timePeriod, onLoadComplete))
	};
};

const mapStateToProps = (state, ownProps) => ({});

export default connect(
	mapStateToProps,
	bindAction
)(DailyFailureChart);



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/DailyFailureChart/DailyFailureChart.js